import e1 from "../elevation/e1.jpeg"
import e2 from "../elevation/e2.jpeg"
import e3 from "../elevation/e3.jpeg"
import e4 from "../elevation/e4.jpeg"
import e5 from "../elevation/e5.jpeg"
import e6 from "../elevation/e6.jpeg"
import e7 from "../elevation/e7.jpeg"
import e8 from "../elevation/e8.jpeg"
import e9 from "../elevation/e9.jpeg"




function Elevation() {
  return (

    <div class="container">
      <h1>Elevation Work</h1>
      <h4>Some of our recent work.</h4>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img src={e1} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e2} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e3} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e4} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e5} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e6} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e7} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e8} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={e9} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
      </div>
      <p><a class="btn btn-success" href="https://www.instagram.com/invites/contact/?igsh=1izl3bvvj2uj3&utm_content=zvshzkp">View more &raquo;</a></p>
      <hr class="featurette-divider" /></div>
  );
}

export default Elevation;
